import styled from 'styled-components';
import { selectThemeSemantics } from '../../../styling';
import { CanvasLayer } from '../../layers';

export const CollapsibleSurface = styled.div.attrs(() => ({
    className: 'ap-collapsible-surface'
}))`
    width: 100%;
    height: 100%;
    overflow: auto;
`;

export const CollapsibleWrapper = styled(CanvasLayer).attrs(() => ({
    className: String('ap-collapsible-wrapper')
}))`
    border: ${({ theme: { collapsible: { composites } } }) => composites.rootBorder}; 
    box-sizing: border-box;
    min-width: 100px;
    overflow: hidden;
    width: 100%;
    padding: ${selectThemeSemantics(({ gap }) => `${gap.m} ${gap.l}`)};
    div:first-child { border-top: none; }
`;
